export const translationHu = {
  header: {
    menu: {
      backToYettel: 'Vissza a Yettel.hu-ra',
      backToYettelB2B: 'Vissza az üzleti portálra',
      account: 'Yettel fiók',
    },
  },
  errorPage: {
    header: `Hoppá!<br />Váratlan hiba történt`,
    subHeader: 'Próbáld újra később, ha továbbra sem sikerül, vedd fel velünk a kapcsolatot chat-en.', //ez link. Dorka TODO: chat link
  },
  notConfirmedEmail: {
    header: 'Hoppá!<br />Úgy látjuk neked már küldtünk megerősítő e-mailt.',
    subHeader:
      'Úgy látjuk kaptál tőlünk megerősítő e-mailt az elmúlt 24 órában. Kérlek nézd meg az e-mail fiókodat és aktiváld regisztrációd.',
    action: 'Vissza a yettel.hu-ra',
  },
  initialPasswordSet: {
    header: 'Fiók létrehozása',
    subHeader: 'Add meg az új fiókodhoz tartozó jelszót',
    subHeaderDuringLoading: 'Kérlek várj, amíg ellenőrizzük a fiókod.',
    createAccount: 'Létrehozás',
    success: {
      header: 'A fiókodat sikeresen létrehoztuk',
      subHeader: 'Tovább a belépéshez',
    },
    error: {
      header: 'Hoppá!<br/>Váratlan hiba történt',
      subHeader: 'A fiókot nem sikerült létrehozni. Kérjük próbáld újra később.',
    },
    missingSession: {
      header: 'Hoppá!<br/>Valami hiba történt',
      subHeader: 'A fiókot nem lehet létrehozni.',
    },
    invalidSession: {
      header: 'Hoppá!<br/>Érvénytelen azonosító',
      subHeader: 'A fiókot nem lehet létrehozni.',
    },
    continueToAccount: 'Tovább a Fiókomhoz',
    tryAgain: 'Újrapróbálom',
  },
  changeEmail: {
    flow: {
      header: {
        getEmail: 'E-mail cím módosítása',
        confirmEmail: 'E-mail cím hitelesítés',
        confirmEmailApp: 'E-mail cím hitelesítése',
        confirmPhone: 'SMS-hitelesítés',
        success: 'Sikeres módosítás',
        failed: 'Hoppá! Váratlan hiba történt',
      },
      text: {
        getEmail:
          'Add meg az e-mail címet, amit a jövőben kapcsolattartásra használhatunk, és ahova a hitelesítő kódot küldhetjük.',
        confirmEmail:
          'A hitelesítő kódot a megadott e-mail címedre elküldtük, néhány percbe telhet, mire megérkezik.<br />Ellenőrizd a beérkező leveleket, a spam mappát is, majd írd be az alábbi mezőbe a kódot:',
        confirmPhone:
          'A hitelesítő kódot elküldtük a megadott telefonszámodra, néhány percbe telhet, mire megérkezik. A kapott kódot írd be a lenti mezőbe.',
        success: 'A módosítás sikeres volt, térj vissza a főoldalra.',
        successApp: 'A módosítás sikeres volt, jelentkezz be ismét az appba.',
        failed: 'Sajnos valami hiba történt, próbáld meg újra később.',
        failedApp: 'Sajnos valami hiba történt, próbáld meg újra később.',
      },
    },
    buttonTextOk: 'Vissza a főoldalra',
    buttonTextFail: 'Vissza a Fiók beállításához',
    goToLogin: 'Belépek',
    retry: 'Újrapróbálom',
  },
  changePhone: {
    flow: {
      header: {
        selectPhone: 'Telefonszám-hitelesítés',
        differentPhone: 'Telefonszám-hitelesítés',
        confirmPhone: 'Telefonszám-hitelesítés',
        emailVerification: 'E-mail cím hitelesítés',
        emailVerificationApp: 'E-mail cím hitelesítése',
        success: 'Sikeres módosítás',
        failed: 'Hoppá! Váratlan hiba történt',
      },
      text: {
        selectPhone:
          'Add meg azt a telefonszámot, amit a jövőben kapcsolattartásra használhatunk, és ahová a hitelesítő kódot küldhetjük.',
        differentPhone:
          'Add meg azt a telefonszámot, amit a jövőben kapcsolattartásra használhatunk, és ahová a hitelesítő kódot küldhetjük. ',
        confirmPhone:
          'A hitelesítő kódot elküldtük a megadott telefonszámodra, néhány percbe telhet, mire megérkezik. A kapott kódot írd be a lenti mezőbe.',
        emailVerification:
          'A hitelesítő kódot a megadott e-mail címedre elküldtük, néhány percbe telhet, mire megérkezik.<br />Ellenőrizd a beérkező leveleket, a spam mappát is, majd írd be az alábbi mezőbe a kódot:',
        emailVerificationApp:
          'A hitelesítő kódot kapcsolattartói e-mail címedre elküldtük, néhány percbe telhet, mire megérkezik.<br />Ellenőrizd a beérkező leveleket, a spam mappát is, majd írd be az alábbi mezőbe a kódot:',
        success: 'A módosítás sikeres volt, térj vissza a főoldalra.',
        successApp: 'A módosítás sikeres volt, jelentkezz be ismét az appba.',
        failed: 'Sajnos valami hiba történt, próbáld meg újra később.',
      },
    },
    buttonTextOk: 'Vissza a főoldalra',
    buttonTextFail: 'Vissza a Fiók beállításához',
    buttonTextBack: 'Vissza',
    goToLogin: 'Belépek',
    retry: 'Újrapróbálom',
  },
  changePassword: {
    header: 'Add meg új jelszavad',
    subHeader: 'Adj meg egy új jelszót, ami megfelel a feltételeknek.',
    saveButton: 'Tovább',
    success: {
      header: 'Sikeres módosítás',
      subHeader: 'A módosítás sikeres volt, térj vissza a belépéshez.',
      headerb2b: 'Jelszó beállítása sikeres',
      subHeaderb2b: (email: string) =>
        `Sikeresen beállítottad új jelszavad a(z) ${email} e-mail címhez tartozó Yettel fiókodhoz.`,
      backToWeb: 'Vissza a webre',
      backToApp: 'Vissza az appba',
    },
    error: {
      header: 'Hoppá!<br/>Váratlan hiba történt',
      subHeader: 'Sajnos valami hiba történt, próbáld meg újra később.',
    },
    errorPasswordReuse: {
      header: 'Hoppá!<br/>Ezt a jelszót már használtad',
      subHeader:
        'A maximális biztonság érdekében adj meg egy olyan jelszót, amelyet korábban még nem alkalmaztál a Yettel fiókodban.',
    },
    continueToAccount: 'Belépek',
    backToEdit: 'Vissza a fiókszerkesztéshez',
    continueToHome: 'Folytatás',
    tryAgain: 'Újrapróbálom',
    invalidSession: {
      header: 'Érvénytelen link!',
      subHeader: 'Nincs ilyen, vagy lejárt megerősítő link.',
    },
  },
  emailConfirm: {
    header: 'E-mail cím visszaigazolása',
    subHeader: 'Kérlek várj amíg visszaigazoljuk az email címed.',
    success: {
      header: `Email cím visszaigazolása sikeres`,
      subHeader: 'Sikeresen visszaigazoltuk az e-mail címed.',
      continueToHome: 'Folytatás',
    },
    turis: {
      header: `E-mail cím visszaigazolása sikeres`,
      subHeader: 'Köszönjük! Kérjük, térj vissza a folyamathoz, és folytasd a lépéseket.',
    },
    error: {
      header: `Hoppá!<br />Váratlan hiba történt`,
      subHeader: 'Nem sikerült visszaigazolni az e-mail címed. Kérjük próbáld újra később.',
      continueToYettel: 'Vissza a yettel.hu-ra',
    },
    missingSession: {
      header: 'Hoppá!<br />A megerősítő e-mail lejárt kérj újat',
      subHeader: 'Az e-mail címet nem lehet visszaigazolni. Kérj egy másik linket, hogy megerősíthes a fiókod.',
    },
  },
  homePage: {
    header: 'Fiókbeállítások',
    tabs: {
      home: 'Fiók főoldal',
      settings: 'Fiókbeállítások',
    },
  },
  accountSettings: {
    accountDataCard: {
      header: 'Fiók adatok',
      nameLabel: 'Fiókhoz tartozó név',
      nameFormat: 'Érvénytelen név',
      emailLabel: 'E-mail cím',
      emailLabelAgain: 'E-mail cím újra',
      phoneLabel: 'Telefonszám',
      registrationType: 'Regisztráció típusa',
      registrationTypeEmail: 'E-mail címmel',
      modifyButton: 'Módosítás',
      saveButton: 'Mentés',
      cancelButton: 'Elvetés',
      errors: {
        emptyEmail: 'Az e-mail cím nem lehet üres.',
        invalidEmail: 'Érvényes e-mail címet kell megadnod.',
        emptyName: 'A név nem lehet üres.',
      },
    },
    passwordDataCard: {
      header: 'Jelszó',
      passwordLabel: 'Fiók jelszó',
      passwordValue: '••••••••',
      modifyButton: 'Módosítás',
    },
    oauth: {
      header: 'Biztonság',
      connect: {
        google: 'Belépek Google fiókkal',
        facebook: 'Belépek Facebook fiókkal',
        apple: 'Belépek Apple fiókkal',
      },
      disconnect: {
        google: 'Google fiók leválasztása',
        facebook: 'Facebook fiók leválasztása',
        apple: 'Apple fiók leválasztása',
      },
    },
    deleteAccountCard: {
      header: 'Fiók törlése',
      deleteButton: 'Törlöm a Yettel fiókom',
    },
    b2bInfoCard: {
      header: 'Fiókadatok, Fiók törlése',
      title: (appointmentBookingUrl: string) =>
        `Ha nevet, email címet szeretnél módosítani, kérlek, vedd fel a kapcsolatot ügyfélszolgálatunkkal, vagy személyes kapcsolattartóddal! <br />Telefonos elérhetőségünk: <a href="tel:1220"><strong><u>1220</u></strong></a>, vagy <a href="${appointmentBookingUrl}" target="_blank" rel="noreferrer noopener">foglalj időpontot üzletünkbe!</a>`,
    },
    mfa: {
      setupAction: 'Többlépcsős azonosítás társítása',
      modifyAction: 'Második faktor módosítása',
      disconnectAction: 'Többlépcsős azonosítás leválasztása',
      list: {
        header: 'Autentikátorhoz kötött jelszavad',
        name: 'Neve',
        time: 'Időpont',
        generateNewCode: 'Új kódot generálok',
      },
      setup: {
        title: 'Többlépcsős azonosítás társítása',
        content: 'Védd meg fiókodat többlépcsős azonosítással!',
        moreLink: 'Többet szeretnék tudni',
        mfaTypeLabel: 'Válaszd ki az azonosítás másik lépcsőjét',
        mfaTypeSMS: 'SMS-ben kérem a kódot',
        mfaTypeAuthenticator: 'Autentikátort használok',
        continue: 'Tovább',
        cancel: 'vissza',
      },
      smsSetup: {
        title: 'Mobilszám megadása az ellenőrzéshez',
        titleb2b: 'Megerősítő telefonszám hozzáadása',
        content: 'Add meg a mobilszámot, ahova az ellenőrző kódot küldjük.',
        contentb2b:
          'Adj meg egy telefonszámot, amihez köthetjük a második biztonsági vonalat a fiókod védelmében! Olyan számot válassz, ami tud SMS-t fogadni és amihez tartósan hozzáférsz!',
        failedToSend: 'A megadott telefonszám nem tartozik az előfizetésedhez.',
        phoneNumberLabel: 'Másodlagos telefonszám',
        phoneNumberLabelTooltip: 'Nem kell beírnod a szóközöket vagy a kötőjeleket.',
        continue: 'Jóváhagyom és tovább',
        cancel: 'vissza',
      },
      smsConfirm: {
        title: 'Igazold telefonszámod az ellenőrző kóddal',
        content: (phoneNumber: string) =>
          `Az ellenőrző kódot elküldtük SMS-ben a ${phoneNumber} végű telefonszámodra.<strong>Ellenőrizd az üzeneteidet, majd add meg a kódot.</strong>`,
        verificationCodeLabel: 'ellenőrző kód',
        verificationCodeHint: 'Nem kaptad meg SMS-ben a kódot?',
        continue: 'Belépek',
        cancel: 'Add meg az ellenőrző kódot telefonhívással.',
        errorInvalidCode: 'Érvénytelen kód',
        error: 'Nem sikerült elküldeni az ellenőrző kódot. Kérjük próbáld újra később.',
      },
      smsSuccess: {
        title: 'Sikeresen beállítottad a Többlépcsős azonosítást',
        content: (email: string) =>
          `Sikeresen beállítottad a többlépcsős azonosítást az ${email} címhez tartozó Yettel fiókodhoz.`,
        continue: 'Rendben',
      },
      smsB2bSuccess: {
        title: 'Sikeres regisztráció',
        content: (email: string) =>
          `Sikeresen regisztráltad a(z) ${email} e-mail címedhez tartozó Yettel üzleti fiókodat.`,
        continue: 'Tovább az appba',
      },
      authenticatorSetup: {
        title: 'Add meg az eszközt, amin az autentikátort használni fogod',
        content:
          'Generálunk egy kódot, amit meg kell adnod az Authenticator alkalmazás társításához kivéve ha QR-kódal szeretnél autentikálni.',
        nameLabel: 'Eszköz neve',
        nameLabelTooltip:
          'Olyan nevet válassz, ami nem tartalmaz speciális karaktert és mindig tudod melyik fiókodat jelöli.',
        continue: 'Társító kód generálása',
        cancel: 'vissza',
        error: `Nem sikerült előállítani a társító kódot. Kérjük próbáld újra később.`,
      },
      authenticatorCodeGen: {
        title: 'Jelszótársító kód',
        content:
          'Ezt a kódot másold be az Authenticator alkalmazás megfelelő mezőjébe vagy olvasd be a QR kódot, hogy létrehozd a második lépcsőt.',
        copy: 'Másolás',
        continue: 'Tovább az ellenőrzéshez',
      },
      authenticatorSuccess: {
        title: 'Sikeresen beállítottad a Többlépcsős azonosítást',
        content: (email: string) =>
          `Sikeresen beállítottad a Többlépcsős azonosítást <strong> ${email} </strong> e-mail címhez tartozó yettel fiókodhoz.`,
        continue: 'Rendben',
      },
    },
    smsLoginError: {
      title: `Hoppá!<br />Úgy néz ki csak SMS-el vagy bejelentkezve`,
      content: `Ezt a felületet csak emailcím+jelszó szintű bejelentkezéssel tudod kezelni. Jelentkezz be így vagy térj vissza a főoldalra`,
      primaryAction: `Belépés fiókkal`,
      secondaryAction: `Vissza a Yettel.hu-ra`,
    },
  },
  dialogSet: {
    leaveDialog: {
      title: 'Biztos, hogy elhagyod az oldalt?',
      content: 'A módosítások el fognak veszni.',
      okLabel: 'Maradok',
      cancelLabel: 'Oldal elhagyása',
    },
    changeDialog: {
      title: 'Biztos, hogy elveted a módosításokat?',
      content: 'A módosítások el fognak veszni.',
      okLabel: 'Megtartás',
      cancelLabel: 'Elvetem',
    },
    successDialog: {
      title: 'Sikeres módosítás',
      subHeader: 'Sikeresen módosítottad a fiókbeállításokat.',
      okLabel: 'Rendben',
    },
    errorDialog: {
      title: 'Hoppá!<br />Váratlan hiba történt',
      content: 'Fiókbeállítások módosítása sikertelen. Kérjük próbáld újra később.',
      okLabel: 'Rendben',
    },
    emailChangeSuccessDialog: {
      title: 'Kérjük erősítsd meg új e-mail címed',
      content:
        'Az e-mail cím módosítása a megerősítést követően fejeződik be. A megerősítéshez tartozó linket elküldtük az új e-mail címedre.',
      cancelLabel: 'Vissza a Yettel fiókhoz',
    },
    deleteAccountDialog: {
      title: 'Biztos, hogy törölni szeretnéd Yettel fiókod?',
      content:
        'Ha törlöd a fiókod, a Telenort a jövőben csak egy új regisztráció után fogod tudni használni. A fiók törlése a fiókodhoz hozzáadott előfizetéseidet nem érinti.',
      cancelLabel: 'Mégsem',
      dangerLabel: 'Fiók törlése',
      errorTitle: 'Hoppá!<br /> Váratlan hiba történt',
      errorConfirm: 'Bezárás',
      successTitle: 'Fiókod törlésre került.',
      successContent:
        'Fiókod törlésre került, nem tudsz ezután belépni a felületeinkre ezzel az e-mail cím+jelszó párossal.',
      successConfirm: 'Vissza a Yettel.hu-ra',
      cantDeleteTitle: 'Ezt a fiókot nem törölheted.',
      yoloContent: (videoChatUrl: string) =>
        `A fiókodban YettelYepp típusú előfizetés található így ezt a fiókot nem törölheted. Vedd fel velünk a kapcsolatot <a href="${videoChatUrl}" target="_blank" rel="noreferrer noopener">chat</a>-en, hogy segíthessünk.`,
      tvContent: (videoChatUrl: string) =>
        `A fiókodban Yettel TV típusú előfizetés található így ezt a fiókot nem törölheted. Vedd fel velünk a kapcsolatot <a href="${videoChatUrl}" target="_blank" rel="noreferrer noopener">chat</a>-en, hogy segíthessünk.`,
      cantDeleteConfirm: 'Vissza a fiókhoz',
    },
  },
  passwordSet: {
    password: 'Új jelszó',
    passwordAgain: 'Új jelszó még egyszer',
    passwordOriginal: 'Eredeti jelszó',
    criteria: 'A jelszónak tartalmaznia kell',
    criteria1: 'Kisbetűket',
    criteria2: 'Nagybetűket',
    criteria3: 'Legalább egy számot',
    criteria4: 'Legalább egy speciális karaktert',
    error: {
      doesntMatch: 'A beírt jelszavak nem egyeznek.',
    },
  },
  forgottenPassword: {
    header: (lock?: boolean): string => (lock ? 'Jelszó módosítás' : 'Elfelejtett jelszó'),
    subHeader:
      'A jelszóváltoztatáshoz add meg Yettel fiókodhoz tartozó e-mail címedet, ahova az új jelszó beállításához szükséges linket küldhetjük.',
    send: 'Küldés',
    sendApp: 'Tovább',
    emailLabel: 'E-mail cím',
    success: {
      header: 'Az e-mailt elküldtük',
      subHeader:
        'Amennyiben olyan e-mail címet adtál meg, amihez tartozik Yettel fiók, akkor a jelszóváltoztatáshoz szükséges teendőket a megadott címre elküldtük. Nézd meg, és kövesd az utasításokat.',
      subHeaderB2b: (email: string) =>
        `A jelszóváltoztatáshoz szükséges teendőket elküldtük a(z) <strong>${email}</strong> címre. Nézd meg és kövesd az utasításokat a jelszó módosításhoz.`,
      resend: 'E-mail újraküldése',
      backToYettel: 'Vissza a belépéshez',
      backToYettelApp: 'Vissza a bejelentkezéshez',
    },
    error: {
      header: 'Hoppá!<br />Váratlan hiba történt',
      subHeader: 'Sajnos valami hiba történt, próbáld meg újra később.',
      tryAgain: 'Újrapróbálom',
      invalidEmail: 'Érvénytelen e-mail cím.',
    },
  },
  loginRegister: {
    register: {
      box: {
        header: 'Yettel fiók regisztráció',
        name: 'Név',
        email: 'E-mail cím',
        emailTooltip:
          'Ezzel az e-mail címel tudod azonosítani magad a yettel.hu rendszerében. Egy olyan email cím legyen, amihez mindíg hozzáférsz.',
        password: 'Jelszó',
        passwordAgain: 'Jelszó még egyszer',
        passwordHint:
          'A jelszónak tartalmaznia kell: kisbetűt, nagybetűt, egy számot, egy speciális karaktert, és minimum 10, maximum 24 karakter hosszú lehet',
        register: 'Regisztráció',
        back: 'Vissza',
        oauthSectionLabel: 'vagy',
        oauthGoogle: 'Regisztráció Google fiókkal',
        oauthFacebook: 'Regisztráció Facebook fiókkal',
        error: 'A fiók regisztráció sikertelen. Kérjük próbáld újra később',
        errorInvalidEmail: 'Érvénytelen e-mail cím',
        errorAccountAlreadyExists: (loginUrl: string, forgottenPasswordUrl: string) =>
          `Ehhez az e-mail címhez már van fiókod. <a href="${loginUrl}">Lépj be</a> vagy <a href="${forgottenPasswordUrl}">Kérj jelszó emlékeztetőt.</a>`,
        errorMissingWFIN: 'Hibás e-mail cím, hívd a 1220-at, hogy kollégánk segíthessen.',
        loginWithSMS: 'Belépés SMS kóddal',
        loginWithYolo: 'Belépek',
        loginCommon: 'Belépek',
        passwordTooltip:
          'A jelszónak tartalmaznia kell:<br/>' +
          '- Kisbetűt<br/>' +
          '- Nagybetűt<br/>' +
          '- Legalább egy számot<br/>' +
          '- Legalább egy speciális karaktert<br/>' +
          '- Minimum 10 maximum 24 karaktert',
      },
      hero: {
        header: 'Intézd ügyeidet online Yettel fiókkal!',
        desc: (link: string) =>
          `Nincs még fiókod? Regisztrálj pár kattintással. Ha elakadtál, kérj segítséget <a href="${link}">chat</a>-en.`,
      },
      result: {
        header: 'Yettel fiók regisztráció',
        subHeader: 'Az e-mailt elküldtük',
        desc: 'A megadott e-mail címedre elküldtük az aktiváló linket tartalmazó e-mail-t. Kérjük, ellenőrizd postafiókodat és véglegesítsd regisztrációdat, erre 24 óra áll rendelkezésedre, utána újra kell kezdened a regisztrációs folyamatot.',
        resend: 'E-mail újra küldése',
        backToYettelAccount: 'Vissza a belépéshez',
      },
      registrationComplete: {
        header: 'A fiókodat sikeresen létrehoztuk',
        desc: 'Tovább a fiókhoz',
        goToLogin: 'tovább a bejelentkezéshez',
      },
      registrationFailed: {
        header: 'Hoppá!<br />Váratlan hiba történt',
        desc: 'Valami hiba történt, vedd fel velünk a kapcsolatot cheten vagy próbáld meg később.', // itt chat Dorka TODO: make it link
        tryAgain: 'Vissza a regisztrációhoz',
      },
    },
    registerWebView: {
      box: {
        header: 'Yettel fiók létrehozása',
        title: 'Hozz létre egy fiókot! Ezt az e-mail címet fogjuk kapcsolattartásra is használni a későbbiekben.',
        continue: 'Tovább',
        error: 'Váratlan hiba történt, kérjük próbáld újra később.',
      },
    },
    registerB2bWebView: {
      acceptTerms: {
        title: 'Nyilatkozatok',
        topText: (url: string | undefined) =>
          `Az "Elfogadom" gombbal hozzájárulsz egy Yettel Business Fiók létrehozásához, és elfogadod a <a href="${url}">Felhasználási feltételeket</a>. Ezzel a korábbi Yettel Fiókod (ha volt) hozzáférését lezárjuk, de az ottani adatokat ezután is eléred itt, az appban – például számlák és szerződések.<br/>Az alábbi funkciók jelenleg csak üzleteinkben vagy ügyfélszolgálaton érhetők el:`,
        topList: `<ul><li>Számlázási beállítások kezelése</li><li>Hívásrészletező igénylése</li><li>Mobilfizetési tranzakciók lekérdezése (pl: parkolás).</li></ul>`,
        bottomText: `Ennek megfelelően a felek a közöttük hatályban lévő ÁSZF rendelkezéseit közös akaratukkal, az alábbiak szerint módosítják:<br/>Az Előfizető a Yettel Business Fiókban:`,
        bottomList: `<ul><li>Az elektronikus számla szolgáltatást számlázási címenként nem rendelheti meg és nem mondhatja le (egy számlázási címen lévő több előfizetés esetén valamennyire érvényes az elektronikus számla szolgáltatás), valamint a hozzá kapcsolódó esetleges kiegészítő szolgáltatásokat nem módosíthatja (ÁSZF törzs, 7.1.3.3. Számlázás és annak módjai)</li><li>A számlaértesítési hívószám és/vagy értesítési e-mail címet nem regisztrálhatja, nem módosíthatja vagy törölheti (ÁSZF törzs, 7.1.3.3. Számlázás és annak módjai)</li><li>Hívásrészletezőt nem igényelhet (ÁSZF törzs, 11.2. Számlás Előfizetők – tételes számlamelléklet és hívásrészletező igénylése)</li><li>MobilVásárlási tranzakciókhoz kapcsolódó információkat nem éri el és a szolgáltatással kapcsolatos beállításokat nem végezheti el, valamint nem módosíthatja (ÁSZF 1/A melléklet, 6.10. MobilVásárlás).</li></ul>`,
        ok: 'Elfogadom',
        cancel: 'Vissza',
      },
      form: {
        title: 'Regisztráció',
        header: 'A Regisztrációhoz add meg kapcsolattartói e-mail címedet, ahova a hitelesítő kódot küldhetjük.',
        infoBox:
          'Fontos, hogy ugyanazt az e-mail címet add meg, amit korábban kapcsolattartói e-mail címként rögzítettél.',
        email: 'E-mail cím',
        send: 'Küldés',
      },
      result: {
        title: 'Az E-mailt elküldtük',
        header:
          'Nyisd meg az e-mailt, és a kapott kódot a Tovább gombra lépve írd be a megfelelő helyre. Ezzel hitelesíted az e-mail címedet, és megerősíted, hogy valóban te kezdeményezted a belépést.',
        resend: 'E-mail újraküldése',
        send: 'Tovább a kódbeíráshoz',
      },
      emailOtp: {
        title: (email: string | undefined) =>
          `Add meg a hitelesítő kódodat, amit e-mail-ben küldtünk a(z) <strong>${email}</strong> címedre.`,
      },
      newPassword: {
        title: 'Jelszó beállítása',
        header: (email: string | undefined) =>
          `Add meg új jelszavad a(z) <strong>${email}</strong> e-mail címedhez tartozó Yettel üzleti fiókodhoz.`,
        send: 'Mentés',
      },
      mfa: {
        title: 'Megerősítő telefonszám hozzáadása',
        header:
          'Adj meg egy telefonszámot, amit második biztonsági lépésként használhatunk fiókod védelmére. Olyat adj meg, ami tud SMS-t fogadni, és mindig elérhető számodra.',
        select: 'Telefonszám',
        placeholder: 'Válassz a számok közül',
        send: 'Küldés',
      },
    },
    otp: {
      header: 'Aktiváló link',
      title: 'Küldtünk egy e-mail-t az aktiváló kódoddal, kérlek, add meg itt a kapott kódot:',
      sendAgain: 'Újra küldés',
      back: 'Vissza',
      invalidCode: 'A megadott aktiváló kód nem megfelelő',
      webView: {
        header: 'E-mail megerősítés',
        title: (email: string | undefined) =>
          `Megerősítő e-mailt küldtünk a(z) <strong>${email}</strong> címre. Kattints az e-mailben lévő gombra, vagy írd be ide a kapott kódot.`,
        changeEmail: 'Másik e-mail címet adok meg',
        sendAgain: 'Új kódot kérek',
        invalidCode: 'A megadott aktiváló kód nem megfelelő',
      },
    },
  },
  migra: {
    first: {
      header: 'Frissítsd a fiókod!',
      subtitle:
        'Megújul a Yettel fiók, az új fiókban átláthatóbban kezelheted az előfizetéseid, gyorsabb és biztonságosabb lesz.',
      subtitle2:
        'A fiókmegújításhoz mindössze hitelesítened kell a telefonszámod pár egyszerű lépésben. A frissítéssel lehetőséged lesz részt venni a nyereményjátékban is.',
      register: 'Tovább',
    },
    error: {
      header: 'Sajnáljuk, úgy tűnik nem sikerült a regisztráció',
      description:
        'Hiba történt az adatok rögzítése közben, kérjük, lépj vissza a főoldalra, és indítsd el újra a folyamatot.',
      backButton: 'Vissza a főoldalra',
      title: 'Hiba történt',
      notFound: 'A megadott migrációs munkamenet nem található.',
      loadFailed: 'Nem sikerült betölteni a migrációs adatokat.',
      backToApp: 'Vissza az alkalmazásba',
    },
    group2: {
      title: 'Group2 Migráció',
      description: 'Ez a Group2 migrációs folyamat. (Később kerül kidolgozásra)',
      back: 'Vissza',
    },
    phoneVerification: {
      title: 'Telefonszám-hitelesítés',
      description:
        'Add meg azt a telefonszámot, amit a jövőben kapcsolattartásra használhatunk, és ahová a hitelesítő kódot küldhetjük.',
      subscriptionsLabel: 'Hangalapú előfizetéseid',
      useOther: 'Mást adok meg',
      continue: 'Tovább',
      success: 'Sikeres hitelesítés!',
    },
    second: {
      header: 'Frissítsd a fiókod!',
      description1:
        'Megújul a Yettel fiók! Az új fiókban átláthatóbban kezelheted az előfizetéseid, gyorsabb és biztonságosabb lesz.',
      description2:
        'Ahhoz, hogy 2026. április 1. után is gond nélkül be tudj lépni, most arra kérünk, hogy frissítsd a fiókod.',
      description3: 'Ez egy egyszeri azonosítás, ami néhány perc alatt elvégezhető.',
      description4: 'A frissítéssel automatikusan részt vehetsz egy nyereményjátékban is.',
      dapButton: 'DÁP alkalmazás',
      videochatButton: 'Videóchat',
      appointmentButton: 'Időpontfoglalás',
      leaveButton: 'Vissza a belépésre',
      heroTitle: 'Intézd ügyeidet online Yettel fiókkal!',
      heroSubtitle: '',
    },
    success: {
      header: 'Sikeres regisztráció',
      description: 'Gratulálunk! Most már csak be kell jelentkezned új és biztonságos fiókodba.',
      descriptionLoggedIn:
        'Úgy látjuk már be vagy lépve egy fiókkal, maradsz azzal bejelentkezve vagy ezzel az újjal szeretnél tovább menni?',
      descriptionApp: 'Gratulálunk! Most már csak be kell jelentkezned új és biztonságos fiókodba.',
      continueButton: 'Tovább a bejelentkezéshez',
      continueButtonApp: 'Belépek',
      keepLoggedInButton: 'Maradok bejelentkezve',
      switchAccountButton: 'Belépek az újjal',
      gameConsent:
        'A gomb megnyomásával hozzájárulok ahhoz, hogy részt vegyek a nyereményjátékban, elfogadom a {gameRules} és az {privacyPolicy}.',
      gameRulesLinkText: 'játékszabályzatot',
      privacyPolicyLinkText: 'adatvédelmi tájékoztatót',
      skipGame: 'Nem játszom, tovább',
      heroSubtitle: '',
    },
    lockout: {
      header: 'Gyanús tevékenységet észleltünk, ezért letiltottunk',
      description: 'Biztonsági okokból átmenetileg letiltottunk, kérjük, próbálj meg bejelentkezni később újra.',
      exitButton: 'Kilépek a folyamatból',
      exitButtonWebview: 'Vissza a yettel.hu-ra',
    },
    notRelevant: {
      header: 'Sajnáljuk, fiókodat nem tudod frissíteni',
      description:
        'Technikai hiba miatt nem tudod fiókodat frissíteni, kérünk, hívd ügyfélszolgálatunkat (1220), hogy kollégánk tájékozthasson a továbbiakról.',
      exitButton: 'Kilépés',
    },
    alreadyMigrated: {
      header: 'Ezzel az azonosítóval már van fiókod',
      description: 'A fiókfrissítést már korábban elvégezted a kiválasztott azonosítóval!',
      retryButton: 'Újrapróbálom',
      exitButton: 'Kilépek a folyamatból',
    },
    emailConfirmation: {
      header: 'Sikeres e-mail cím rögzítés',
      description: (email: string) =>
        `A továbblépéssel hozzájárulsz, hogy a ${email} e‑mail címet és a későbbiekben megadott telefonszámot ügyfélszintű kapcsolattartási elérhetőségként használjuk, mely minden a - kiválasztott ügyfélazonosítódhoz - tartozó előfizetésnél módosítja a korábban megadott kapcsolattartási, értesítési és - ha volt - marketing célú elérhetőségeket.`,
      continueButton: 'Tovább',
    },
  },
  password: {
    passwordHint: {
      title: 'A jelszónak tartalmaznia kell:',
      lowerCase: 'Kisbetűt',
      upperCase: 'Nagybetűt',
      atLeastANumber: 'Legalább egy számot',
      atLeastASpecial: 'Legalább egy speciális karaktert',
      lengthCheck: 'Minimum 10, maximum 24 karaktert',
    },
    errors: {
      lowerCase: 'A jelszavad nem tartalmaz kisbetűt',
      upperCase: 'A jelszavad nem tartalmaz nagybetűt',
      atLeastANumber: 'A jelszavad nem tartalmaz legalább egy számot',
      atLeastASpecial: 'A jelszavad nem tartalmaz legalább egy speciális karatert',
      lengthCheck: 'Ez a jelszó nem minimum 10 karakter és nem maximum 24',
      general: 'A jelszó nem felel meg a követelményeknek',
    },
  },
  emailChange: {
    header: 'E-mail cím módosítása',
    title: 'Add meg az új e-mail címedet.',
    email: 'E-mail cím',
    emailAgain: 'E-mail cím még egyszer',
    error: {
      invalidEmail: 'Érvénytelen e-mail cím',
      emailMismatch: 'Az e-mail címek nem egyeznek',
      general: 'Az e-mail cím módosítása sikertelen. Kérjük próbáld újra később.',
    },
    continue: 'Tovább',
    otpHeader: 'Küldtünk egy e-mailt az aktiváló kódoddal',
  },
  emailChangeBlock: {
    header: 'Biztosan tiltani szeretnéd az e-mail cím módosítást?',
    content1:
      'Úgy látjuk e-mail címet szeretnél módosítani. Ha nem te kezdeményezted a folyamatot, akkor tiltsd le és javasoljuk, hogy változtass jelszót.',
    block: 'E-mal cím csere tiltása',
    cancel: 'Mégsem',
    error: {
      header: 'Hoppá!<br />Váratlan hiba történt',
      subHeader: 'Az email cím csere tiltása nem sikerült. Kérjük próbáld újra később.',
      back: 'Vissza',
    },
  },
  accessibility: {
    loading: 'Betöltés folyamatban',
    code: 'Kód',
    qrCode: 'QR kód',
  },
  yeppRegistration: {
    webcomponent: {
      continue: 'Tovább',
      back: 'Vissza',
      captchaRequired: 'Kérjük, igazolja, hogy nem robot.',
      requestNewCode: 'Új kódot kérek',
      timerSeconds: 'mp',
      invalidCode: (code: string, attempts: number) =>
        `A(z) ${code} kód nem megfelelő, már csak ${attempts} próbálkozásod maradt.`,
      tooManyAttempts: (code: string) => `A(z) ${code} kód nem megfelelő, túl sokszor próbálkoztál.`,
      expiredCode: (code: string) => `A(z) ${code} kód nem megfelelő, a kód érvényessége lejárt, kérj újat.`,
      generalError: 'Hoppá! Váratlan hiba történt, kérjük próbáld újra később.',
      useCurrentPhone: 'A most megvásárolt számot használom',
      enterDifferentPhone: 'Mást adok meg',
      phoneNumber: 'Telefonszám',
      phoneNumberPlaceholder: '+36...',
      finished: 'Kész! Átirányítás...',
      redirecting: 'Átirányítás...',
      bannedHeader: 'Gyanús tevékenységet észlelünk, ezért letiltottunk',
      bannedText: 'Biztonsági okokból átmenetileg letiltottunk, kérjük, próbálj meg bejelentkezni később újra.',
      invalidEmail: 'Ezt az e-mail címet nem használhatod, kérjük adj meg egy másikat.',
      emailAlreadyExists: 'Ezzel az e-mail címmel már regisztráltak egy fiókot, kérjük adj meg egy másikat.',
      invalidPhoneNumber: 'Ezt a telefonszámot nem használhatod, kérjük adj meg egy másikat.',
      unexpectedError: {
        title: 'Hoppá!<br />Váratlan hiba történt',
        description:
          'A folyamat megszakadt, kérünk, próbáld újra később. Ha mégsem sikerül, vedd fel velünk a kapcsolatot telefonos ügyfélszolgálati vonalunkon: 1220.',
      },
      voiceSubs: 'Hangalapú előfizetéseid',
      emailExists: 'Úgy látjuk, ezzel az e-mail címmel már regisztráltál fiókot.',
      loginHere: 'Jelentkezz be!',
    },
    flow: {
      header: {
        registration: 'Yettel ügyfélprofil regisztrálás',
        emailVerification: 'E-mail hitelesítés',
        phoneVerification: 'Telefonszám-hitelesítés',
      },
      text: {
        enterEmail:
          'Add meg az e-mail címet, amit a jövőben kapcsolattartásra használhatunk, és ahova a hitelesítő kódot küldhetjük.',
        emailVerification:
          'A hitelesítő kódot a megadott e-mail címedre elküldtük, néhány percbe telhet, mire megérkezik.<br />Ellenőrizd a beérkező leveleket, a spam mappát is, majd írd be az alábbi mezőbe a kódot:',
        phoneVerification: 'Adj meg egy SMS fogadásra képes mobilszámot, amit kapcsolattartásra használhatunk.',
        phoneCode:
          'A hitelesítő kódot elküldtük a megadott telefonszámodra, néhány percbe telhet, mire megérkezik. A kapott kódot írd be a lenti mezőbe.',
      },
      warning: {
        title: 'Megtartanád a számod?',
        description: 'Ha számot szeretnél hordozni válaszd a Mást adok meg opciót, és add meg jelenlegi számod.',
      },
    },
  },
  onboarding: {
    login: {
      header: 'Bejelentkezés',
      emailLabel: 'E-mail cím',
      emailPlaceholder: 'Add meg az e-mail címed',
      emailRequired: 'Az e-mail cím megadása kötelező',
      emailInvalid: 'Kérjük, adj meg egy érvényes e-mail címet',
      passwordLabel: 'Jelszó',
      passwordPlaceholder: 'pelda@email.com',
      passwordRequired: '********',
      forgotPassword: 'Elfelejtett jelszó?',
      loginButton: 'Bejelentkezés',
      smsLoginButton: 'Bejelentkezés SMS-sel',
      registerButton: 'Regisztráció',
      orText: 'vagy',
    },
    identifyMyself: {
      header: 'Azonosítom magam',
      description: 'Jó hírünk van! Yettel fiókod mostantól egyszerűbb és biztonságosabb.',
      benefit1: 'Bevezettük a kétfaktoros azonosítást, amihez hitelesítjük e-mail címed.',
      benefit2: 'Biometrikus azonosítást is használhatsz a gyorsabb belépéshez.',
      benefit3:
        'Belépés után minden hozzád tartozó előfizetésed és szolgáltatásod automatikusan megtalálod egy helyen, a Yettel fiókodban!',
      instruction: (link: string) =>
        `Ehhez csak végig kell menned egy gyors ügyfélazonosítási folyamaton, melyről bővebben <a href="${link}" target="_blank" rel="noopener noreferrer">itt</a> tájékozódhatsz. Válassz az alábbi lehetőségek közül <strong>vagy csak látogass el valamelyik Yettel üzletbe!</strong>`,
      dapButton: 'DÁP alkalmazás',
      videoChatButton: 'Videochat',
      appointmentButton: 'Időpont az üzletbe',
      appointmentButtonApp: 'Időpont az üzletbe',
      selfieButton: 'Szelfis azonosítás',
    },
    dapCode: {
      header: 'DÁP azonosító kód',
      warningTitle: 'Aktivált DÁP appra van szükséged',
      warningText: 'Ha nincs aktivált DÁP alkalmazásod, akkor válassz más azonosítási módot.',
      loading: 'QR kód betöltése...',
      instruction: 'Nyisd meg a DÁP alkalmazást a mobilodon, és a QR kód olvasójával olvasd be ezt a kódot!',
      backToLogin: 'Vissza a bejelentkezéshez',
      toDapApp: 'Tovább a DÁP alkalmazásra',
      showQRCode: 'Mutasd a QR kódot',
      appTitle: 'Az azonosítás megkezdődött',
      appText:
        'A DÁP alkalmazásban hagyd jóvá a két adatkérést, ne lépj ki addig, amíg a folyamat tart. A jóváhagyás után térj vissza ide, a Yettel alkalmazásba.',
    },
    kyc: {
      headerWeb: 'Szelfis azonosítás a Yettel appban',
      webTextFull1: 'A Yettel Appban villámgyorsan azonosíthatod magadat.',
      webTextFull2:
        'Ehhez: <ul><li>készítsd elő a személyidet</li><li>olvasd be a QR-kódot, és folytasd az appban</li></ul>',
      webTextMobile1: 'A szelfis azonosításhoz ezekre lesz szükséged:',
      webTextMobile2: '<strong><ul><li>Magyar személyi igazolvány</li></ul></strong>',
      webTextMobile3: '<strong><ul><li>Yettel alkalmazás</li></ul></strong>',
      webTextMobile4: 'Ha az app még nincs telepítve a telefonodra, a lenti gombok egyből a letöltésre visznek.',
      webTextMobile5: 'Azonosítás után jelentkezz be, és folytathatod is, amit elkezdtél.',
      headerApp: 'Szelfis azonosítás',
      subHeaderApp: 'Hozd létre Yettel fiókodat 2 perc alatt!',
      stepHeader: '<strong>Mi kell a regisztráláshoz?</strong>',
      step1: '18. betöltött életév',
      step2: 'Személyi igazolvány és szelfi',
      step3: 'Saját neveden lévő előfizetés',
      stepsNote: 'A képeket kizárólag gépi azonosításra használjuk. A szelfit nem állítjuk be profilképnek.',
      infoHeader: 'Készítsd elő a magyar személyazonosító igazolványodat',
      qrInstruction: '<strong>Olvasd be, és folytasd az azonosítást a Yettel appban</strong>',
      continueToYettelApp: 'Tovább a Yettel appra',
      showQRCode: 'Másik telefonon folytatom',
      acceptTerms: (link: string) =>
        `A továbblépéssel elfogadom a <a href="${link}" target="_blank" rel="noopener noreferrer">Yettel Adatvédelmi Nyilatkozatát</a>, és hozzájárulok a személyes adataim kezeléséhez.`,
      register: 'Regisztrálok',
      backToMethodSelection: 'Más azonosítást választok',
      checking: 'Majdnem kész<br />ellenőrizzük az adataidat.',
      errorTitle: 'Hoppá!<br />Váratlan hiba történt',
      errorText:
        'A folyamat megszakadt, kérünk, próbáld újra később vagy vedd fel velünk a kapcsolatot telefonos ügyfélszolgálati vonalunkon: 1220.',
    },
    videoChat: {
      header: 'Videóchat azonosítás',
      description: 'Kapcsolódj munkatársunkhoz videóhíváson keresztül a személyazonosság ellenőrzéséhez.',
    },
    appointment: {
      header: 'Időpontfoglalás',
      description: 'Foglalj időpontot valamelyik üzletünkbe a személyazonosság ellenőrzéséhez.',
    },
    dapVerify: {
      title: 'Sikeres azonosítás, már csak egy lépés van hátra',
      description:
        'Jól haladunk a folyamattal, kérünk, még egyszer hagyd jóvá a DÁP appban az adatátadást, és kész is vagyunk.',
      backToLogin: 'Vissza a bejelentkezéshez',
    },
    selectSubscriber: {
      addNew: 'Más adok meg',
      itsMe: 'Igen én vagyok, tovább',
      chooseAnother: 'Csak a kijelölttel megyek tovább',
      somethingWrong: 'Valami gond van, időpontot foglalok',
      somethingWrongWebview: 'Időpontot foglalok',
      reserve: 'Időpontot foglalok az üzletbe',
      retry: 'Újrapróbálom',
      backToLogin: 'Vissza a bejelentkezéshez',
      backToLoginApp: 'Kilépek a folyamatból',
      oneSubscriber: 'Adataid alapján az alábbi előfizetőt találtuk',
      multipleSubscriber: 'Adataid alapján az alábbi előfizetőket találtuk',
      noSubscriber: 'Adataid alapján nem találtunk meg előfizetőként',
      okDescription:
        'Megújítottuk a Yettel fiókot. Mostantól biztonságosabb és egyszerűbben kezelhető.<br/>A használatához csak be kell azonosítanod magad.',
      okDescriptionApp:
        'Megújítottuk a Yettel fiókot. Mostantól biztonságosabb és egyszerűbben kezelhető.<br/>A használatához csak be kell azonosítanod magad.',
      failedDescription:
        'Amennyiben mégis ügyfelünk vagy, akkor előfordulhat, hogy más adatokkal szerepelsz a rendszerünkben, vagy nem te vagy a szerződés tulajdonosa. Kérünk, fáradj be bármelyik üzletünkbe, vagy <strong>hívd ügyfélszolgálatunkat a 1220-as számon!</strong>',
      failedDescriptionApp:
        'Amennyiben mégis ügyfelünk vagy, akkor előfordulhat, hogy más adatokkal szerepelsz a rendszerünkben, vagy nem Te vagy a szerződés tulajdonosa.<br/>Kérünk, fáradj be bármelyik üzletünkbe, vagy hívd ügyfélszolgálatunkat a 1220-as számon. ',
      warningTitle: 'Adataid alapján több ügyfélazonosítót is találtunk',
      warningDescription:
        'Válaszd ki melyikhez szeretnél most fiókot létrehozni. Ha többet is szeretnél egy helyen kezelni, akkor foglalj időpontot, hogy kollégánk összevonhassa azokat egy azonosító alá.',
    },
    hasEmail: {
      header: 'Ezzel az azonosítóval már létezik fiók',
      description: (email: string) =>
        `A választott ügyfélazonosítóhoz ez az e‑mail cím tartozik:<br/>${email}.<br/>Amennyiben módosítanál rajta, a belépés után, a profilodban tudod megtenni.`,
      note: 'Amennyiben módosítanál rajta a belépés után a profilodban tudod módosítani.',
      continue: 'Tovább a bejelentkezésre',
    },
    finish: {
      header: 'Sikeres regisztráció',
      description: 'Gratulálunk! Most már csak be kell jelentkezned új és biztonságos fiókodba.',
      continue: 'Tovább a bejelentkezéshez',
    },
    hero: {
      heroTitle: 'Intézd ügyeidet online Yettel fiókkal!',
      heroSubtitle: '',
    },
    verificationFlow: {
      header: {
        registration: 'Hozd létre a fiókodat',
        registrationApp: 'Yettel fiók regisztrálása',
        emailVerification: 'E-mail hitelesítés',
        phoneVerification: 'Telefonszám-hitelesítés',
      },
      text: {
        enterEmail:
          'Add meg az e-mail címet, amit a jövőben kapcsolattartásra használhatunk, és ahova a hitelesítő kódot küldhetjük.',
        emailVerification:
          'A hitelesítő kódot a megadott e-mail címedre elküldtük, néhány percbe telhet, mire megérkezik.<br/>Ellenőrizd a beérkező leveleket, a spam mappát is, majd írd be az alábbi mezőbe a kódot:',
        phoneVerification:
          'Add meg azt a telefonszámot, amit a jövőben kapcsolattartásra használhatunk, és ahová a hitelesítő kódot küldhetjük.',
        phoneCode:
          'A hitelesítő kódot elküldtük a megadott telefonszámodra, néhány percbe telhet, mire megérkezik. A kapott kódot írd be a lenti mezőbe.',
      },
    },
    error: {
      queryError: {
        title: 'Hiba történt az adatok fogadása közben',
        description:
          'Hiba történt a DÁP appból érkező adatok fogadása közben, a folyamat megszakadt. Kérjük próbáld meg újra.',
      },
      unexpectedError: {
        title: 'Hoppá!<br />Váratlan hiba történt',
        description:
          'A folyamat megszakadt, kérünk, próbáld újra később. Ha van aktivált DÁP alkalmazásod, és mégsem sikerül az azonosítás, vedd fel velünk a kapcsolatot telefonos ügyfélszolgálati vonalunkon: 1220.',
      },
      permissionError: {
        title: 'Nem engedélyezted az adatátadást, a bejelentkezés megszakadt',
        description:
          'Úgy látjuk, nem engedélyezted a DÁP alkalmazásnak, hogy átadja személyes adataidat. Így sajnos nem tudjuk végrehajtani a belépéshez szükséges azonosítást. Kérjük, a DÁP alkalmazásban engedélyezd az adatátadást, és próbáld újra a QR kód beolvasását.',
      },
      nosubError: {
        title: 'Adataid alapján nem találtunk meg előfizetőként',
        description:
          'Amennyiben mégis ügyfelünk vagy, akkor előfordulhat, hogy más adatokkal szerepelsz a rendszerünkben, vagy nem Te vagy a szerződés tulajdonosa.<br /> Kérünk, fáradj be bármelyik üzletünkbe, vagy hívd ügyfélszolgálatunkat a 1220-as számon.',
      },
      dapError: {
        title: 'Úgy látjuk valami gond van a DÁP alkalmazásoddal',
        description:
          'Ellenőrizd, és próbáld meg újra. Ha nincs aktivált DÁP alkalmazásod, akkor válassz más azonosítási módot.',
      },
      generalError: {
        title: 'Hoppá!<br />Váratlan hiba történt',
        description:
          'A folyamat megszakadt, kérünk, próbáld újra később. Ha mégsem sikerül, vedd fel velünk a kapcsolatot telefonos ügyfélszolgálati vonalunkon: 1220.',
      },
    },
  },
};

export const translationEn: typeof translationHu = {
  header: {
    menu: {
      backToYettel: 'Back to Yettel.hu',
      backToYettelB2B: 'Back to the Business Portal',
      account: 'Yettel account',
    },
  },
  errorPage: {
    header: 'Ups!<br/> Something failed.',
    subHeader: 'An unexpected error happened.',
  },
  notConfirmedEmail: {
    header: 'Ups!<br /> You have already received a confirmation email',
    subHeader:
      'You need to confirm your email address to log in. We have sent a confirmation email to your Yettel account.',
    action: 'Back to yettel.hu',
  },
  initialPasswordSet: {
    header: 'Create account',
    subHeader: 'Create a password for your new account',
    subHeaderDuringLoading: 'Please wait until we check your account',
    createAccount: 'Create',
    success: {
      header: 'Your account has been created',
      subHeader: 'Check your orders',
    },
    error: {
      header: 'Ups!<br/>An unexpected error happened',
      subHeader: 'Your account has failed to be created. Try again later.',
    },
    missingSession: {
      header: 'Ups!<br/>Invalid url!',
      subHeader: 'Account cannot be created',
    },
    invalidSession: {
      header: 'Ups!<br/>Invalid account creation url!',
      subHeader: 'Account cannot be created',
    },
    continueToAccount: 'Continue to my account',
    tryAgain: 'Try again',
  },
  changeEmail: {
    flow: {
      header: {
        getEmail: 'Enter your email address',
        confirmEmail: 'Email verification',
        confirmEmailApp: 'Email verification',
        confirmPhone: 'SMS verification',
        success: 'Successful change',
        failed: 'Oops! An unexpected error occurred',
      },
      text: {
        getEmail:
          'Enter the email address that we can use for communication in the future, and where we can send the verification code.',
        confirmEmail:
          'We sent the verification code to your email address, it may take a few minutes to arrive.<br />Check your inbox, including the spam folder, then enter the code in the field below:',
        confirmPhone:
          'We sent the verification code to your contact phone number, it may take a few minutes to arrive.<br />Enter the received code in the field below.',
        success: 'The change was successful, return to the main page.',
        successApp: 'The change was successful, return to the app.',
        failed: 'Unfortunately, an error occurred, please try again later.',
        failedApp: 'Unfortunately, an error occurred, please try again later.',
      },
    },
    buttonTextOk: 'Back to main page',
    buttonTextFail: 'Back to account settings',
    goToLogin: 'Sign in',
    retry: 'Try again',
  },
  changePhone: {
    flow: {
      header: {
        selectPhone: 'Phone number verification',
        differentPhone: 'Phone number verification',
        confirmPhone: 'Phone number verification',
        emailVerification: 'Email verification',
        emailVerificationApp: 'E-mail verification',
        success: 'Successful change',
        failed: 'Oops! An unexpected error occurred',
      },
      text: {
        selectPhone:
          'Enter the phone number that we can use for communication in the future, and where we can send the verification code.',
        differentPhone:
          'Enter the phone number that we can use for communication in the future, and where we can send the verification code.',
        confirmPhone:
          'We sent the verification code to your phone number, it may take a few minutes to arrive. Enter the received code in the field below.',
        emailVerification: 'To change your phone number, please verify your email address.',
        emailVerificationApp: 'To change your phone number, please verify your email address.',
        success: 'The change was successful, return to the main page.',
        successApp: 'The change was successful, return to the app.',
        failed: 'Unfortunately, an error occurred, please try again later.',
      },
    },
    buttonTextOk: 'Back to main page',
    buttonTextFail: 'Back to account settings',
    buttonTextBack: 'Back',
    goToLogin: 'Sign in',
    retry: 'Try again',
  },
  changePassword: {
    header: 'Change password',
    subHeader: 'Enter your new password to your account.',
    saveButton: 'Save',
    success: {
      header: 'Password change succeeded',
      subHeader: 'You have successfully changed the password, continue the login',
      headerb2b: 'Password change succeeded',
      subHeaderb2b: (email: string) =>
        `You have successfully changed the password to your account with the email address ${email}.`,
      backToWeb: 'back to the web',
      backToApp: 'back to the app',
    },
    error: {
      header: 'Ups!<br/>An unexpected error happened',
      subHeader: 'Failed to change the password to your account.',
    },
    errorPasswordReuse: {
      header: 'Oops!<br/>You have already used this password',
      subHeader:
        'For maximum security, please choose a password that you have not used before for your Yettel account.',
    },
    continueToAccount: 'Log in',
    continueToHome: 'Continue',
    backToEdit: 'Back to edit',
    tryAgain: 'Try again',
    invalidSession: {
      header: 'Invalid password change url!',
      subHeader: 'Expired or invalid url.',
    },
  },
  emailConfirm: {
    header: 'Confirm email address',
    subHeader: 'Please wait until we confirm your email address.',
    success: {
      header: `Email address confirmed`,
      subHeader: 'We have successfully confirmed your email address.',
      continueToHome: 'Continue',
    },
    turis: {
      header: `Email address confirmed`,
      subHeader: 'Thank you! Please return to the process to continue your journey.',
    },
    error: {
      header: 'Ups!<br />An unexpected error happened',
      subHeader: 'Failed to confirm your email address. Please try again later.',
      continueToYettel: 'Back to yettel.hu',
    },
    missingSession: {
      header: 'Ups!<br />The confirmation email has expired, please request a new one',
      subHeader: 'Email address cannot be confirmed.',
    },
  },
  homePage: {
    header: 'Account settings',
    tabs: {
      home: 'Account home',
      settings: 'Account settings',
    },
  },
  accountSettings: {
    accountDataCard: {
      header: 'Account data',
      nameLabel: 'Name',
      emailLabel: 'Email address',
      emailLabelAgain: 'Email address again',
      nameFormat: 'Invalid name',
      phoneLabel: 'Phone number',
      registrationType: 'Type of registration',
      registrationTypeEmail: 'E-mail',
      modifyButton: 'Modify',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      errors: {
        emptyEmail: 'The email address cannot be empty.',
        invalidEmail: 'You must give a valid email address.',
        emptyName: 'The name cannot be empty.',
      },
    },
    passwordDataCard: {
      header: 'Password',
      passwordLabel: 'Account password',
      passwordValue: '••••••••',
      modifyButton: 'Modify',
    },
    deleteAccountCard: {
      header: 'Delete account',
      deleteButton: 'Delete my Yettel account',
    },
    b2bInfoCard: {
      header: 'Account Details, Delete Account',
      title: (appointmentBookingUrl: string) =>
        `If you would like to update your name or email address, please contact our customer service team or your personal account manager. <br />You can reach us by phone at <strong><u>v1220</u></strong>, or <a href="${appointmentBookingUrl}" target="_blank" rel="noreferrer noopener">book an appointment at our store!</a>`,
    },
    mfa: {
      setupAction: 'Setup multi-factor authentication',
      modifyAction: 'Modify Second Factor',
      disconnectAction: 'Disconnect multi-factor authentication',
      list: {
        header: 'Your password is connected to Authenticator',
        name: 'Name',
        time: 'Time',
        generateNewCode: 'Generate new code',
      },
      setup: {
        title: 'Setup multi-factor authentication',
        content: 'Multi-factor authentication protects your account from unauthorized access.',
        moreLink: 'Learn more',
        mfaTypeLabel: 'Choose the second step of authentication',
        mfaTypeSMS: 'I want to use SMS code',
        mfaTypeAuthenticator: 'I want to use Authenticator',
        continue: 'Continue',
        cancel: 'Back',
      },
      smsSetup: {
        title: 'Enter your phone number',
        titleb2b: 'Enter a mobile number for verification',
        content: 'Enter a phone number you trust to receive the code.',
        contentb2b:
          'Enter a phone number to link a second security layer to your account for enhanced protection! Choose a number that can receive SMS messages and that you have long-term access to!',
        phoneNumberLabel: 'Secondary phone number',
        phoneNumberLabelTooltip: 'You do not need to enter spaces or dashes',
        failedToSend: 'Failed to send the verification code. Please try again later.',
        continue: 'Approve and continue',
        cancel: 'Back',
      },
      smsConfirm: {
        title: 'Confirm your phone number by entering the verification code.',
        content: (phoneNumber: string) =>
          `We will send the verification code (SMS) to your phone number ending with ${phoneNumber}. <strong>Check your messages and enter the code.</strong>`,
        verificationCodeLabel: 'Verification code',
        verificationCodeHint: "Didn't receive the verification code?",
        continue: 'Log in',
        cancel: 'I choose another way to set up multi-factor authentication.',
        errorInvalidCode: 'Invalid code',
        error: 'Failed to send the verification code. Please try again later.',
      },
      smsSuccess: {
        title: 'You have successfully set up multi-factor authentication!',
        content: (email: string) =>
          `You have successfully set up multi-factor authentication for your yettel account with the email address ${email}.`,
        continue: 'Log in',
      },
      smsB2bSuccess: {
        title: 'Successful registration',
        content: (email: string) =>
          `Successfully registrated your Yettel business account with the email address ${email}`,
        continue: 'Continue to app',
      },
      authenticatorSetup: {
        title: 'Enter the name of the device you will use the authenticator with',
        content: 'You will need this code to connect Authenticator.',
        nameLabel: 'Name',
        nameLabelTooltip:
          'Choose a name that does not contain special characters and always know which account it refers to.',
        continue: 'Generate authenticator code',
        cancel: 'Back',
        error: `Failed to generate the verification code. Please try again later.`,
      },
      authenticatorCodeGen: {
        title: 'Password authenticator code',
        content: 'Copy this code to the appropriate field of the authenticator to create the second factor.',
        copy: 'copy',
        continue: 'Continue',
      },
      authenticatorSuccess: {
        title: 'You have successfully set up multi-factor authentication!',
        content: (email: string) =>
          `You have successfully set up multi-factor authentication for your yettel account with the email address ${email}.`,
        continue: 'Log in',
      },
    },
    oauth: {
      header: 'Security',
      connect: {
        google: 'Login with Google',
        facebook: 'Login with Facebook',
        apple: 'Login with Apple',
      },
      disconnect: {
        google: 'Remove Google login',
        facebook: 'Remove Facebook login',
        apple: 'Remove Apple login',
      },
    },
    smsLoginError: {
      title: `Ups!<br />It looks like you can only log in with SMS or logged in`,
      content: `You can only manage this interface with an email address + password level login. Log in this way or return to the home page`,
      primaryAction: `Log in with account`,
      secondaryAction: `Back to fiok.yettel.hu`,
    },
  },
  dialogSet: {
    leaveDialog: {
      title: 'Are you sure you want to leave this page',
      content: 'All changes will be lost',
      okLabel: 'Stay',
      cancelLabel: 'Leave without saving',
    },
    changeDialog: {
      title: 'Are you sure you want to discard changes?',
      content: 'All changes will be lost',
      okLabel: 'Megtartás',
      cancelLabel: 'Elvetem',
    },
    successDialog: {
      title: 'Success',
      subHeader: 'You have successfully modified your account.',
      okLabel: 'Ok',
    },
    errorDialog: {
      title: 'Oops!<br />Something went wrong',
      content: 'An error occured while trying to update your account information. Please try again later.',
      okLabel: 'Ok',
    },
    emailChangeSuccessDialog: {
      title: 'Please validate your new email address',
      content:
        'The change of email address will take effect after validation. We have sent a validation email to your new address.',
      cancelLabel: 'Back to my Yettel account',
    },
    deleteAccountDialog: {
      title: 'Are you sure you want to delete your account?',
      content:
        'If you delete your account, you may only use MyTelenor after registering a new account. Deleting your account does not affect your current subscriptions.',
      cancelLabel: 'Cancel',
      dangerLabel: 'Delete account',
      errorTitle: 'Oops!<br />An unexpected error happened',
      errorConfirm: 'Close',
      successTitle: 'Your account has been deleted.',
      successContent: 'Your account has been deleted, you will not be able to log in with this email password pair.',
      successConfirm: 'back to yettel.hu',
      cantDeleteTitle: 'You cannot delete this account.',
      yoloContent: (videoChatUrl: string) =>
        `This account has a YettelYepp type subscription, so you cannot delete this account. Contact us through <a href="${videoChatUrl}" target="_blank" rel="noreferrer noopener">video chat</a> to help.`,
      tvContent: (videoChatUrl: string) =>
        `This account has a Yettel TV type subscription, so you cannot delete this account. Contact us through <a href="${videoChatUrl}" target="_blank" rel="noreferrer noopener">video chat</a> to help.`,
      cantDeleteConfirm: 'Try again',
    },
  },
  passwordSet: {
    password: 'New password',
    passwordAgain: 'New password again',
    passwordOriginal: 'Current password',
    criteria: 'The password must contain',
    criteria1: 'Lower case letters',
    criteria2: 'Upper case letters',
    criteria3: 'At least a number',
    criteria4: 'At least a special character',
    error: {
      doesntMatch: "The passwords doesn't match.",
    },
  },
  forgottenPassword: {
    header: (lock?: boolean): string => (lock ? 'Change password' : 'Change password'),
    subHeader:
      'Enter the email address of your account where we can send information how to change or set your password.',
    send: 'Send',
    sendApp: 'Continue',
    emailLabel: 'Email address',
    success: {
      header: 'Email sent',
      subHeader:
        'If you entered an email address that is associated with a Yettel account, the steps needed to change your password have been sent to the address you provided. Please check it and follow the instructions.',
      subHeaderB2b: (email: string) =>
        `We have sent an email how to change your password to the ${email} email address.`,
      resend: 'Send again',
      backToYettel: 'Back to Yettel',
      backToYettelApp: 'Back to Sign in',
    },
    error: {
      header: 'Ups!<br />An unexpected error happened',
      subHeader: 'Unfortunately, an error occurred, please try again later.',
      tryAgain: 'Try again',
      invalidEmail: 'Invalid email address.',
    },
  },
  loginRegister: {
    register: {
      box: {
        header: 'Yettel account registration',
        name: 'What is your name?',
        email: 'Enter your email address',
        emailTooltip:
          'You can identify yourself in the yettel.hu system with this email address. It should be an email address you have access to.',
        register: 'Register',
        back: 'Back',
        password: 'Password',
        passwordAgain: 'Password again',
        passwordHint:
          'The password must contain: lowercase letter, uppercase letter, a number, a special character, and must be at least 10, maximum 24 characters long',
        oauthSectionLabel: 'or',
        oauthGoogle: 'Register with Google account',
        oauthFacebook: 'Register with Facebook account',
        error: 'Failed to create account. Please try again later',
        errorInvalidEmail: 'Invalid email address',
        errorAccountAlreadyExists: (loginUrl: string, forgottenPasswordUrl: string) =>
          `You already have an account with this email address. <a href="${loginUrl}">Log in</a> or <a href="${forgottenPasswordUrl}">Request a password reminder.</a>`,
        errorMissingWFIN: 'Invalid e-mail adress, call 1220 to reach our customer service.',
        loginWithSMS: 'Login with SMS',
        loginWithYolo: 'Login',
        loginCommon: 'Login',
        passwordTooltip:
          'The password must contain:<br/>' +
          '- Lower case letters<br/>' +
          '- Upper case letters<br/>' +
          '- At least a number<br/>' +
          '- At least a special character<br/>' +
          '- Minimum 10 maximum 24 characters',
      },
      hero: {
        header: 'Manage your subscription online with Yettel account!',
        desc: (link: string | undefined) =>
          `Don't have an account yet? Register a new account with a few clicks. ${link ? 'If you are stuck, ask for help via <a href="' + link + '">chat</a>' : ''}.`,
      },
      result: {
        header: 'Yettel account registration',
        subHeader: 'The email has been sent',
        desc: 'We have sent an email with the activation link to the email address you provided. Please check your mailbox and finalize your registration! You can activate your Yettel account within 24 hours of registration, after that you will have to start the registration process again!',
        resend: 'Resend email',
        backToYettelAccount: 'Back to login',
      },
      registrationComplete: {
        header: 'Your account has been created',
        desc: 'Check your orders',
        goToLogin: 'continue to login',
      },
      registrationFailed: {
        header: 'Ups!<br />An unexpected error happened',
        desc: 'Something went wrong, contact us through video chat or try again later.',
        tryAgain: 'back to registration',
      },
    },
    registerWebView: {
      box: {
        header: 'Create Yettel account',
        title: 'Create a Yettel account! We will get in touch with you later via the given e-mail.',
        continue: 'Continue',
        error: 'Something went wrong, please try again later!',
      },
    },
    registerB2bWebView: {
      acceptTerms: {
        title: 'Declarations',
        topText: (url: string | undefined) =>
          `By clicking the "Accept" button, you agree to create a Yettel Business Account and accept the <a href="${url}">Terms of Use</a>. Your previous Yettel Account (if any) will be closed, but you will still have access to the data from it here in the app – for example, invoices and contracts.<br/>The following functions are currently only available in our stores or at customer service:`,
        topList: `<ul><li>Managing billing settings</li><li>Requesting call detail records</li><li>Querying mobile payment transactions (e.g., parking).</li></ul>`,
        bottomText: `Accordingly, the parties hereby amend the provisions of the General Terms and Conditions in effect between them, by mutual consent, as follows:<br/>The Subscriber in the Yettel Business Account:`,
        bottomList: `<ul><li>Cannot order or cancel the electronic invoicing service per billing address (if multiple subscriptions exist under one billing address, the electronic invoicing service applies to all), and cannot modify any associated supplementary services (GTC core, 7.1.3.3. Billing and its methods)</li><li>Cannot register, modify, or delete the invoice notification phone number and/or notification email address (GTC core, 7.1.3.3. Billing and its methods)</li><li>Cannot request call detail records (GTC core, 11.2. Postpaid Subscribers – requesting itemized invoice and call detail records)</li><li>Cannot access information related to Mobile Payment transactions or modify any service-related settings (GTC Annex 1/A, 6.10. Mobile Payment).</li></ul>`,
        ok: 'Accept',
        cancel: 'Back',
      },
      form: {
        title: 'Registration',
        header:
          'To complete your registration, please provide your contact email address where we can send the verification code.',
        infoBox:
          'It is important to use the same email address for your registration that you previously registered as your contact email.',
        email: 'Email address',
        send: 'Send',
      },
      result: {
        title: 'Email sent',
        header:
          'Open your email and enter the received code in the appropriate field after clicking Continue. This will verify your email address and confirm that you initiated the login.',
        resend: 'Resend email',
        send: 'Continue to enter code',
      },
      emailOtp: {
        title: (email: string | undefined) => `Enter the verification code we sent to <strong>${email}</strong>.`,
      },
      newPassword: {
        title: 'Set your password',
        header: (email: string | undefined) =>
          `Set a new password for your Yettel business account associated with the email address <strong>${email}</strong>.`,
        send: 'Save',
      },
      mfa: {
        title: 'Add a backup phone number',
        header:
          'Provide a phone number we can use as a second layer of security to protect your account. Make sure it can receive SMS and is always accessible to you.',
        select: 'Phone number',
        placeholder: 'Select from the list',
        send: 'Send',
      },
    },
    otp: {
      header: 'Activation link',
      title: 'We have sent an email with the activation code. Please enter the code you received.',
      sendAgain: 'Send again',
      back: 'back',
      invalidCode: 'The entered activation code is not valid',
      webView: {
        header: 'Email confirmation',
        title: (email: string | undefined) =>
          `We have sent an email to <strong>${email}</strong>. Click on the button in the email, or enter the received code.`,
        changeEmail: 'Use a different email',
        sendAgain: 'Resend',
        invalidCode: 'The entered activation code is not valid',
      },
    },
  },
  migra: {
    first: {
      header: 'Update your account!',
      subtitle:
        'The Yettel account is being renewed. In the new account, you can manage your subscriptions more transparently, and it will be faster and more secure.',
      subtitle2:
        'To renew your account, you just need to verify your phone number in a few simple steps. By updating, you will also have the opportunity to participate in a prize draw.',
      register: 'Continue',
    },
    error: {
      header: 'Sorry, the registration seems to have failed',
      description:
        'An error occurred while recording the data. Please go back to the home page and restart the process.',
      backButton: 'Back to homepage',
      title: 'An error occurred',
      notFound: 'The specified migration session was not found.',
      loadFailed: 'Failed to load migration data.',
      backToApp: 'Back to app',
    },
    group2: {
      title: 'Group2 Migration',
      description: 'This is the Group2 migration process. (To be developed later)',
      back: 'Back',
    },
    phoneVerification: {
      title: 'Phone number verification',
      description: 'Enter the phone number we can use for contact and where we can send the verification code.',
      subscriptionsLabel: 'Your voice subscriptions',
      useOther: 'Use a different number',
      continue: 'Continue',
      success: 'Verification successful!',
    },
    second: {
      header: 'Update your account!',
      description1:
        'The Yettel account is being renewed! In the new account, you can manage your subscriptions more transparently, and it will be faster and more secure.',
      description2:
        'To continue using your account without any issues after April 1, 2026, we ask you to update your account now.',
      description3: 'This is a one-time identification that can be completed in a few minutes.',
      description4: 'By updating, you will automatically be entered into a prize draw.',
      dapButton: 'DÁP app',
      videochatButton: 'Video chat',
      appointmentButton: 'Book appointment',
      leaveButton: 'Back to login',
      heroTitle: 'Manage your affairs online with Yettel account!',
      heroSubtitle: '',
    },
    success: {
      header: 'Successful registration',
      description: 'Congratulations! You have completed all the preparations to create your new, secure account.',
      descriptionLoggedIn:
        'Congratulations! You have completed all the preparations to create your new, secure account. You can now log in to your account.',
      descriptionApp: 'Congratulations! Now you just need to log in to your new and secure account.',
      continueButton: 'Continue to login',
      continueButtonApp: 'Login',
      keepLoggedInButton: 'Keep me logged in',
      switchAccountButton: 'Login with new',
      gameConsent:
        'By pressing the button, I consent to participate in the sweepstakes, I accept the {gameRules} and the {privacyPolicy}.',
      gameRulesLinkText: 'sweepstakes rules',
      privacyPolicyLinkText: 'Data Management Policy',
      skipGame: "I don't want to play, continue",
      heroSubtitle: '',
    },
    lockout: {
      header: 'We detected suspicious activity, so we blocked you',
      description: 'For security reasons, we have temporarily blocked you. Please try logging in again later.',
      exitButton: 'Exit the process',
      exitButtonWebview: 'Back to yettel.hu',
    },
    notRelevant: {
      header: 'Sorry, you cannot update your account',
      description:
        'Due to a technical error, you cannot update your account. Please call our customer service (1220) so our colleague can inform you about the next steps.',
      exitButton: 'Exit',
    },
    alreadyMigrated: {
      header: 'You already have an account with this identifier',
      description: 'You have already completed the account update with the selected identifier!',
      retryButton: 'Retry',
      exitButton: 'Exit the process',
    },
    emailConfirmation: {
      header: 'Successful email address registration',
      description: (email: string) =>
        `By continuing, you consent to using the ${email} email address and the phone number you will provide later as customer-level contact information, which will update the previously provided contact, notification, and - if any - marketing contact details for all subscriptions associated with the - selected customer ID -.`,
      continueButton: 'Continue',
    },
  },
  password: {
    passwordHint: {
      title: '* The password must contain:',
      lowerCase: 'Lower case letters',
      upperCase: 'Upper case letters',
      atLeastANumber: 'At least a number',
      atLeastASpecial: 'At least a special character',
      lengthCheck: 'Minimum 10, maximum 24 characters',
    },
    errors: {
      lowerCase: 'The password does not contain lower case letters',
      upperCase: 'The password does not contain upper case letters',
      atLeastANumber: 'The password does not contain at least one number',
      atLeastASpecial: 'The password does not contain at least one special character',
      lengthCheck: 'The password is not long enough',
      general: 'The password does not meet the requirements',
    },
  },
  emailChange: {
    header: 'Change email address',
    title: 'Enter your new email address.',
    email: 'Email address',
    emailAgain: 'Email address again',
    error: {
      invalidEmail: 'Invalid e-mail address',
      emailMismatch: 'The e-mail addresses do not match',
      general: 'Failed to change the e-mail address. Please try again later.',
    },
    continue: 'Continue',
    otpHeader: 'We have sent an e-mail with the activation code',
  },
  emailChangeBlock: {
    header: 'Are you sure you want to block the e-mail address change?',
    content1:
      'It seems that you are trying to change your e-mail address. If it was not you, block it and change your password as soon as you can!',
    block: 'Block e-mail change',
    cancel: 'Cancel',
    error: {
      header: 'Oops!<br />An unexpected error happened',
      subHeader: 'Failed to block the e-mail address change. Please try again later.',
      back: 'Back',
    },
  },
  accessibility: {
    loading: 'Loading',
    code: 'Code',
    qrCode: 'QR code',
  },
  yeppRegistration: {
    webcomponent: {
      continue: 'Next',
      back: 'Back',
      captchaRequired: 'Please verify you are not a robot.',
      requestNewCode: 'Get a new code',
      timerSeconds: 'sec',
      invalidCode: (code: string, attempts: number) =>
        `The ${code} code is incorrect, you have ${attempts} attempt(s) left.`,
      tooManyAttempts: (code: string) => `The ${code} code is incorrect, you have tried too many times.`,
      expiredCode: (code: string) => `The ${code} code is incorrect, the code has expired, please request a new one.`,
      generalError: 'An unexpected error occurred, please try again later.',
      useCurrentPhone: "I'll use the phone number just purchased.",
      enterDifferentPhone: 'Enter a different number',
      phoneNumber: 'Phone number',
      phoneNumberPlaceholder: '+36...',
      finished: 'Finished!',
      redirecting: 'Redirecting...',
      bannedHeader: 'Suspicious activity detected, you have been blocked temporarily',
      bannedText: 'For security reasons, we have temporarily blocked you. Please try again later.',
      invalidEmail: 'Invalid email address, please enter a valid email.',
      emailAlreadyExists: 'An account with this email address already exists, please provide a different one.',
      invalidPhoneNumber: 'Invalid phone number, please enter a valid phone number.',
      unexpectedError: {
        title: 'Oops!<br />An unexpected error occurred',
        description:
          'The process was interrupted, please try again later. If you have an activated DÁP application and the identification still fails, contact us on our customer service line: 1220.',
      },
      voiceSubs: 'Your voice subscriptions',
      emailExists: 'Seems like you already have an account with this email address.',
      loginHere: 'Login here!',
    },
    flow: {
      header: {
        registration: 'Yettel customer profile registration',
        emailVerification: 'Email verification',
        phoneVerification: 'Phone number verification',
      },
      text: {
        enterEmail:
          'Enter the email address that we can use for future contact and where we can send the verification code.',
        emailVerification:
          'The verification code has been sent to the provided email address. It may take a few minutes to arrive.<br />Please check your inbox, including the spam folder, and enter the code in the field below:',
        phoneVerification: 'Enter a mobile phone number capable of receiving SMS that we can use for contact.',
        phoneCode:
          'The verification code has been sent to the provided phone number. It may take a few minutes to arrive. Please enter the received code in the field below.',
      },
      warning: {
        title: 'Would you keep your number?',
        description:
          'If you want to port your number, choose the "Enter a different number" option and provide your current number.',
      },
    },
  },
  onboarding: {
    login: {
      header: 'Login',
      emailLabel: 'Email address',
      emailPlaceholder: 'Enter your email address',
      emailRequired: 'Email address is required',
      emailInvalid: 'Please enter a valid email address',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      passwordRequired: 'Password is required',
      forgotPassword: 'Forgot password?',
      loginButton: 'Log in',
      smsLoginButton: 'Log in with SMS',
      registerButton: 'Register',
      orText: 'OR',
    },
    identifyMyself: {
      header: 'Identify myself',
      description: "With verified identity you can access Yettel's full range of services!",
      benefit1: 'Simplified tariff and device changes',
      benefit2: 'Quick re-ordering of SIM',
      benefit3: 'Complete management options',
      instruction: (link: string) =>
        `To proceed, you need to complete a quick customer identification process. You can learn more about it <a href="${link}" target="_blank" rel="noopener noreferrer">here</a>. Choose from the options below <strong>or simply visit any Yettel store!</strong>`,
      dapButton: 'DÁP application',
      videoChatButton: 'Videochat',
      appointmentButton: 'Book appointment',
      appointmentButtonApp: 'Book appointment',
      selfieButton: 'Identification with selfie',
    },
    dapCode: {
      header: 'DÁP identification code',
      warningTitle: 'You need an activated DÁP app',
      warningText: "If you don't have an activated DÁP application, choose another verification method.",
      loading: 'Loading QR code...',
      instruction: 'Open the DÁP app on your phone and use its QR code reader to scan this code!',
      backToLogin: 'Back to login',
      toDapApp: 'Go to DÁP app',
      showQRCode: 'Show QR code',
      appTitle: 'Identification started',
      appText:
        'In the DÁP app, approve the two data requests, do not exit while the process is ongoing. After approval, return here, to the Yettel app.',
    },
    kyc: {
      headerWeb: 'Verify your identity with a selfie',
      headerApp: 'Selfie verification',
      subHeaderApp: 'Create your Yettel account in just 2 minutes',
      webTextFull1: 'You can identify yourself in the Yettel App in a flash.',
      webTextFull2:
        'To do this: <ul><li>prepare your identity card</li><li>scan the QR code and continue in the app</li></ul>',
      webTextMobile1: 'For this you will need:',
      webTextMobile2: '<strong><ul><li>your Hungarian ID card</li></ul></strong>',
      webTextMobile3: '<strong><ul><li>the Yettel application</li></ul></strong>',
      webTextMobile4:
        'If you don’t have our app installed yet, the buttons below will take you straight to the download page.',
      webTextMobile5: 'Once your identity is verified sign in and continue where you left off.',
      stepHeader: '<strong>What do you need to register?</strong>',
      step1: 'You must be at least 18 years old',
      step2: 'A photo of your Hungarian ID and a selfie',
      step3: 'A subscription registered in your name',
      stepsNote:
        'We use the photos only for automated identity verification. We won’t use your selfie as a profile picture.',
      infoHeader: 'Please have your Hungarian ID card ready',
      qrInstruction: '<strong>Read the QR code to verify your identity in the Yettel app</strong>',
      continueToYettelApp: 'Continue in the Yettel app',
      showQRCode: 'Continue on another device',
      acceptTerms: (link: string) =>
        `By continuing, you accept the <a href="${link}" target="_blank" rel="noopener noreferrer">Yettel Privacy Notice</a> and agree to the processing of your personal data.`,
      register: 'Register',
      backToMethodSelection: 'Choose a different method',
      checking: 'Almost done<br />We are checking your data.',
      errorTitle: 'Oops!<br />An unexpected error occurred',
      errorText: 'The process was interrupted, please try again later or contact our customer service hotline: 1220.',
    },
    videoChat: {
      header: 'Videochat verification',
      description: 'Connect with our representative via video call for identity verification.',
    },
    appointment: {
      header: 'Book an appointment',
      description: 'Schedule a visit to one of our stores for identity verification.',
    },
    dapVerify: {
      title: 'Successful identification, only one step left',
      description:
        'We are progressing well, please approve the data transfer in the DÁP app once more, and we are done.',
      backToLogin: 'Back to login',
    },
    selectSubscriber: {
      addNew: 'Add different',
      itsMe: 'Yes, it is me, continue',
      chooseAnother: 'Continue with selected',
      somethingWrong: 'Something is wrong, I book an appointment',
      somethingWrongWebview: 'Book an appointment',
      reserve: 'Book an appointment',
      retry: 'Retry',
      backToLogin: 'Back to login',
      backToLoginApp: 'Leave and return to login',
      oneSubscriber: 'Based on your data, we found the following subscriber',
      multipleSubscriber: 'Based on your data, we found the following subscribers',
      noSubscriber: 'Based on your data, we did not find you as a subscriber',
      okDescription:
        'We have renewed your Yettel account. From now on, it is more secure and easier to manage.<br/>To use it, you just need to identify yourself.',
      okDescriptionApp:
        'We have revamped the Yettel account. It is now safer and easier to use.<br/>You just need to log in to use it.',
      failedDescription:
        'If you are still our customer, it may be that you are registered in our system with different data, or you are not the owner of the contract. Please visit any of our stores, or <strong>call our customer service at 1220!</strong>',
      failedDescriptionApp:
        'If you are still our customer, it may be that you are registered in our system with different data, or you are not the owner of the contract. Please visit any of our stores, or call our customer service at 1220!',
      warningTitle: 'Based on your data, we found multiple customer identifiers',
      warningDescription:
        'Select which subscription you want to create an account for. If you have multiple subscriptions and want to manage them all in one place, book an appointment so our colleague can merge them under one identifier.',
    },
    hasEmail: {
      header: 'You already have an account with this identifier',
      description: (email: string) => `We found an existing account associated with the email address ${email}.`,
      note: 'If you want to modify it, you can change it in your profile after logging in.',
      continue: 'Continue',
    },
    finish: {
      header: 'Successful registration',
      description: 'Congratulations! You just need to log in to your new and secure account.',
      continue: 'Continue to login',
    },
    hero: {
      heroTitle: 'Manage your affairs online with Yettel account!',
      heroSubtitle: '',
    },
    verificationFlow: {
      header: {
        registration: 'Create your account',
        registrationApp: 'Create Yettel account',
        emailVerification: 'E-mail verification',
        phoneVerification: 'Phone number verification',
      },
      text: {
        enterEmail:
          'Enter the email address that we can use for future contact and where we can send the verification code.',
        emailVerification:
          'To activate, we have sent you an email which may take a few minutes to arrive. Check your inbox (also check the spam folder) and enter the received code here:',
        phoneVerification:
          'Enter the phone number that we can use for future contact and where we can send the verification code.',
        phoneCode:
          'The verification code has been sent to the provided phone number, it may take a few minutes to arrive. Enter the received code in the field below.',
      },
    },
    error: {
      queryError: {
        title: 'Error occurred while receiving data',
        description:
          'An error occurred while receiving data from the DÁP app, the process was interrupted. Please try again.',
      },
      unexpectedError: {
        title: 'Oops!<br />An unexpected error occurred',
        description:
          'The process was interrupted, please try again later. If you have an activated DÁP application and the identification still fails, contact us on our customer service line: 1220.',
      },
      permissionError: {
        title: 'You did not allow data transfer, login was interrupted',
        description:
          'It seems you did not allow the DÁP application to transfer your personal data. Unfortunately, we cannot perform the identification required for login. Please enable data transfer in the DÁP application and try scanning the QR code again.',
      },
      nosubError: {
        title: 'We did not find you as a subscriber based on your data',
        description:
          'If you are still our customer, it may be that you are registered in our system with different data, or you are not the owner of the contract.<br /> Please visit any of our stores, or call our customer service at 1220.',
      },
      dapError: {
        title: 'There is a problem with your DÁP application',
        description:
          'Please check and try again. If you do not have the DÁP application activated, please choose a different identification method.',
      },
      generalError: {
        title: 'Oops!<br />An unexpected error occurred',
        description:
          'The process was interrupted, please try again later. If the identification still fails, contact us on our customer service line: 1220.',
      },
    },
  },
};
